import * as React from 'react';

const SvgXCircleOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M3.75 12.76a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 3.01c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.366 9.75-9.75S17.385 3.01 12 3.01m-1.72 6.969a.75.75 0 1 0-1.06 1.06l1.649 1.65a.1.1 0 0 1 0 .141l-1.65 1.649a.75.75 0 0 0 1.061 1.06l1.65-1.648a.1.1 0 0 1 .14 0l1.65 1.649a.75.75 0 1 0 1.06-1.061l-1.649-1.649a.1.1 0 0 1 0-.141l1.65-1.65a.75.75 0 0 0-1.061-1.06l-1.65 1.649a.1.1 0 0 1-.14 0z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgXCircleOutlined;
